import { faLaptopCode, faHeadset, faHeartbeat, faTv } from '@fortawesome/free-solid-svg-icons';

const servicesData = [
  { 
    title: "Business & Technology Consulting",
    icon: faLaptopCode,
    points: [
      "Supplier & vendor management",
      "Strategic business planning",
      "Digital transformation & automation",
      "Programming, IT, and custom technology solutions"
    ]
  },
  {
    title: "Customer Experience (CX) Outsourcing",
    icon: faHeadset,
    points: [
      "Professional call center operations",
      "Tailored CX solutions for banking, food, entertainment, healthcare, and more",
      "24/7 Multi-channel support (phone, chat, email, social media)"
    ]
  },
  {
    title: "Healthcare & Professional Services",
    icon: faHeartbeat,
    points: [
      "AI-driven medical billing services",
      "Insurance & warranty company partnerships",
      "Compliance-focused outsourcing for sensitive industries",
      "Healthcare technology & back-office support"
    ]
  },
  {
    title: "Connectivity, Media & Lifestyle",
    icon: faTv,
    points: [
      "TV & internet provider matching",
      "Entertainment and digital media solutions",
      "Warranty & extended protection plans",
      "End-to-end service management for consumer needs"
    ]
  },
];

export default servicesData;